import { render, staticRenderFns } from "./bank-transfer.vue?vue&type=template&id=64f14f8a&scoped=true&"
import script from "./bank-transfer.vue?vue&type=script&lang=js&"
export * from "./bank-transfer.vue?vue&type=script&lang=js&"
import style0 from "./bank-transfer.vue?vue&type=style&index=0&id=64f14f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f14f8a",
  null
  
)

export default component.exports